import { IonIcon, useIonRouter } from '@ionic/react';
import { briefcaseOutline, chevronForwardOutline } from 'ionicons/icons';
import '../../components/ListCard.css';
import { LIST_CARD_TITLE_CLASSES } from '../../components/listCardStyles';

export interface CareerOrganizationCardOrganization {
  id: string;
  name: string;
  image?: string | null;
}

interface CareerOrganizationImageProps {
  organization: CareerOrganizationCardOrganization;
  /** Tailwind size classes of the image box. */
  className?: string;
}

// Image of an organization, or the briefcase placeholder used by the career
// entries of the ProfileTab when it has none.
export const CareerOrganizationImage = ({
  organization,
  className = 'h-12 w-12',
}: CareerOrganizationImageProps) =>
  organization.image ? (
    <img
      src={organization.image}
      alt={`Imagen de ${organization.name}`}
      className={`${className} shrink-0 rounded-xl bg-white object-contain`}
    />
  ) : (
    <div
      className={`${className} flex shrink-0 items-center justify-center rounded-xl bg-[#eef3fa] text-[#0a2a5b]`}
      data-testid="career-organization-placeholder"
    >
      <IonIcon icon={briefcaseOutline} />
    </div>
  );

// Row of the organization listing of the "Red" tab. Opens the organization page.
export const CareerOrganizationCard = ({
  organization,
}: {
  organization: CareerOrganizationCardOrganization;
}) => {
  const ionRouter = useIonRouter();

  return (
    <button
      type="button"
      className="fc-list-card mb-3 flex w-full items-center gap-4 border border-[#e8ebf1] bg-white text-left"
      onClick={() => ionRouter.push(`/app/main/red/entidades/${organization.id}`)}
      data-testid="career-organization-card"
    >
      <CareerOrganizationImage organization={organization} />
      <h2 className={`m-0 min-w-0 flex-1 truncate ${LIST_CARD_TITLE_CLASSES}`}>
        {organization.name}
      </h2>
      <IonIcon icon={chevronForwardOutline} className="shrink-0 text-xl text-slate-400" />
    </button>
  );
};
